import React from "react";

interface Option {
  value: string;
  label: string;
}

interface RadioProps {
  options: Option[];
  value: string;
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  isDisabled?: boolean;
}
export const RadioField: React.FC<RadioProps> = ({
  options = [],
  value,
  label,
  onChange,
  name,
  isDisabled,
}) => {
  return (
    <div className="grid md:grid-cols-3 items-center w-full items-start gap-1 space-y-2">
      <label
        className={`flex items-stretch text-left expandedLabel fontExpand`}
      >
        {label}
      </label>
      {options!.map((option) => {
        return (
          <label
            key={option.value}
            className={`flex items-center gap-x-2 pb-2 expandedLabel fontExpand cursor-pointer ${
              isDisabled ? "opacity-50" : ""
            }`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              disabled={isDisabled}
            />
            <div>{option.label}</div>
          </label>
        );
      })}
    </div>
  );
};
